// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Scale$LumiFacilityMap from "./Scale.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as MapLabel$LumiFacilityMap from "./MapLabel.res.js";
import * as FacilityMap$LumiDocuments from "lumi-documents/lib/es6/src/FacilityMap.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";

function IndicatorObject(props) {
  let __objectStyle = props.objectStyle;
  let objectTransform = props.objectTransform;
  let mapTransform = props.mapTransform;
  let objectStyle = __objectStyle !== undefined ? __objectStyle : ObjectStyle$LumiFacilityMap.empty;
  let scale = Scale$LumiFacilityMap.fixedInScreenSpace(props.scale, mapTransform, undefined, undefined);
  let halfScale = scale / 2;
  let className = ObjectStyle$LumiFacilityMap.className(objectStyle);
  let circle = {
    TAG: "Circle",
    cx: halfScale,
    cy: 0,
    r: halfScale
  };
  return JsxRuntime.jsxs("g", {
    children: [
      JsxRuntime.jsx(FacilityMap$LumiDocuments.Shape.make, {
        shape: circle,
        className: "body",
        style: objectStyle.style
      }),
      LumiReact.renderOption(undefined, objectStyle.label, label => {
        let labelPosition = [
          halfScale,
          0
        ];
        let outerTransform = Transform$Linear.M23f.compose(mapTransform, objectTransform);
        return JsxRuntime.jsx(MapLabel$LumiFacilityMap.make, {
          outerTransform: outerTransform,
          position: labelPosition,
          className: "label is-unselectable",
          fitInside: circle,
          scale: scale,
          children: label
        });
      }),
      LumiReact.renderOption(undefined, objectStyle.title, title => JsxRuntime.jsx("title", {
        children: title
      }))
    ],
    className: className,
    onClick: props.onClick,
    transform: LumiSVG.Transform.Matrix.fromM23f_(objectTransform)
  });
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let make = IndicatorObject;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  make,
}
/* LumiSVG Not a pure module */
